// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 13 13" {...rest} unit={unit}>
		<g id="Player-Cell/Action/Vice-Captain"
		   transform="translate(-24.000000, -24.000000)">
			<polygon id="V" points="32.5535714 24 36.3125 24 31.9464286
			37 28.3303571 37 24 24 27.7410714 24 30.1428571 32.9732143" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/V.js